import React from "react";

const ProductModal = ({ isOpen, products, onClose }) => {
    if (!isOpen) return null;

    // 배경(오버레이) 클릭 시 모달 닫기
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
            onClick={handleOverlayClick}
        >
            <div 
                className="bg-white text-black p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[80vh] overflow-y-auto"
            >
                <h2 className="text-xl font-bold mb-4">네이버 쇼핑 상위 상품 정보</h2>

                {/* 테이블 추가 */}
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300 text-sm">
                        <thead>
                            <tr className="bg-gray-200">
                                <th className="border border-gray-300 px-4 py-2">상품명</th>
                                <th className="border border-gray-300 px-4 py-2">카테고리</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products?.length > 0 ? (
                                products.map((product, index) => {
                                    // console.log("Product Data:", product); // 디버깅용 콘솔 로그
                                    return (
                                        <tr key={index} className="text-center">
                                            <td className="border border-gray-300 px-4 py-2">

                                              <a href={product?.link} target="_blank" rel="noopener noreferrer" className="text-white-500 cursor-pointer hover:text-blue-400">
                                              {product?.title || "제목 없음"}
                                              </a>
                                            </td>
                                            <td className="border border-gray-300 px-4 py-2 text-xs">
                                                {product?.category1 || "없음"}/{product?.category2 || "없음"}/{product?.category3 || "없음"}/{product?.category4 || "없음"}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center py-4">데이터가 없습니다.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* 닫기 버튼 */}
                <button
                    className="mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                    onClick={onClose}
                >
                    닫기
                </button>
            </div>
        </div>
    );
};

export default ProductModal;
